import React from "react";
import "./Footer.css";
import { Nav, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faEnvelope, faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
const Footer = () => {

  const location = useLocation();

  const img_data = [
    "/assets/images/footer/fb.png",
    "/assets/images/footer/google.png",
    "/assets/images/footer/twitter.png",
    "/assets/images/footer/img4.png",
  ]

  const our_programs = ["BBA", "MBA", "CPDM", "CPHAHM"]
  const pages = ["Contact", "Committee", "Fee Structure", "Blog", "Time Table", "Placement" ,"Faculty", "About University", "Recognition & Approval","Admissions Process","Grievance Redressal","Privacy Policy"]

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="row">

            <div className="col-lg-4 col-sm-12">

              <div className="col_div">
                <div className="logo_holder">
                  <img src="/assets/images/footer/logo.png" className="logo_img" />
                </div>
                <div className="address_holder">
                  <p className="title_text">Address:</p>
                  <p className="address">2nd Floor, Office No. 3, M No. 734, Opp High Class Society, Pashan Rd, near Suryadutta College, Patil Nagar, Bavdhan, Pune, Maharashtra 411021</p>
                </div>
              </div>

            </div>

            <div className="col-lg-4 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">Our Programs</p>
                <Nav>
                  <div className="first_nav_div">
                    {our_programs?.map((nav) => {
                      return (
                        <Nav.Item >
                          <NavLink as={Link} className={location.pathname === "/" ? "active" : ""}>
                            <FontAwesomeIcon icon={faAngleRight} /> {nav}
                          </NavLink>
                        </Nav.Item>
                      )
                    })}

                  </div>
                </Nav>

                <div className="social_div">
                  <p className="footer_section_title">Connect With Us socially,</p>
                  <div className="imgs_holder">
                    {img_data?.map((item) => {
                      return (
                        <div className="logo_holder">
                          <img src={process.env.PUBLIC_URL + item} className="social_logo" />
                        </div>
                      )
                    })}
                  </div>
                </div>

              </div>
            </div>

            <div className="col-lg-4 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">Our Programs</p>
                <Nav>
                  <div className="first_nav_div">
                    {pages?.map((nav) => {
                      return (
                        <Nav.Item >
                          <NavLink as={Link} className={location.pathname === "/" ? "active" : ""}>
                            <FontAwesomeIcon icon={faAngleRight} /> {nav}
                          </NavLink>
                        </Nav.Item>
                      )
                    })}

                  </div>
                </Nav>

              </div>
            </div>

          </div>

          <div className="footer_text_div">
            <p className="footer_text">Our DPU Online MBA Course from Your City Location:</p>
            <p className="subtext">Delhi | Hyderabad | Ahmedabad | Bengaluru | Mumbai | Nagpur | Nashik | Surat</p>
          </div>

        </div >
      </section >
    </>
  );
};

export default Footer;
